import './ProductSelector.css';

import { useEffect, useState } from 'react';

import { useConfiguratorContext } from '../ConfiguratorWizard/ConfiguratorContext';
import Loader from '../Loader/Loader';
import ProductCard, { Product } from '../ProductCard/ProductCard';

interface ProductSelectorProps {
  onProductSelected: (val: Product) => void;
}

export default function ProductSelector({
  onProductSelected,
}: ProductSelectorProps) {
  const [selectedProductCode, setSelectedProductCode] = useState<string | null>(
    null,
  );
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { setLang } = useConfiguratorContext();

  useEffect(() => {
    async function fetchProducts() {
      try {
        const res = await fetch('https://tsk-italy.com/wp-json/tsk/products');
        if (!res.ok) {
          throw new Error('Errore nel caricamento dei prodotti');
        }
        const data = await res.json();
        if (!data || data.length === 0) {
          throw new Error('Nessun prodotto trovato');
        }
        setProducts(data);
      } catch (e) {
        console.error(e);
        setError('Nessun prodotto trovato');
      } finally {
        setLoading(false);
      }
    }
    fetchProducts();
  }, []);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      const data = event.data || {};
      if (data.type === 'load') {
        setLang(data.parameters.culture ?? 'it');

        if (data.parameters?.modelCode) {
          setSelectedProductCode(data.parameters.modelCode);
        }
      }
    }

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (products.length > 0 && selectedProductCode) {
      const product = products.find((p) => p.code === selectedProductCode);
      if (product) {
        onProductSelected(product);
      }
    }
  }, [products, selectedProductCode]);

  const handleClick = (product: Product) => {
    setSelectedProductCode(product.code);
    onProductSelected(product);
  };

  return (
    <>
      {loading && <Loader heightSection={'20rem'} />}
      {error && <div>{error}</div>}
      <div id="product-selector">
        {products.map((product) => (
          <ProductCard
            key={product.code}
            product={product}
            isActive={selectedProductCode === product.code}
            onClick={handleClick}
          />
        ))}
      </div>
    </>
  );
}
